document.addEventListener('DOMContentLoaded', () => {
  const menu = document.getElementById('menu') as HTMLElement | null;
  const globalnavi = document.getElementById(
    'globalnavi'
  ) as HTMLElement | null;
  const closeBtn = document.getElementById('close') as HTMLElement | null;

  if (menu && globalnavi && closeBtn) {
    menu.addEventListener('click', () => {
      globalnavi.classList.add('active');
    });

    closeBtn.addEventListener('click', () => {
      globalnavi.classList.remove('active');
    });
  }

  const closeBtn2 = document.getElementById('kinkyuClose');
  const target = document.getElementById('kinkyu');

  if (!closeBtn2 || !target) return;

  closeBtn2.addEventListener('click', () => {
    target.style.display = 'none';
  });
});
